import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { UrlConstants } from '../../../../base/service/serviceConstant';
import { TPIService } from '../../../../base/tpiService';


const DBSuccess = () => {
  const history = useHistory();
  useEffect(()=>{
    const clients:any = localStorage.getItem('drop_box');
    const storageType:any = JSON.parse(clients);
    if(storageType && storageType["access_token"]){
      var requestOptions:any = {
        method: 'GET',
        redirect: 'follow',
        url:  UrlConstants
          .tpiCBAPI(`cloudstorage/dropbox/getaccesstoken?code=${code}&redirect=`+window.location.origin+"/dbsuccess"),
        headers: { Authorization: `Bearer ${storageType["access_token"]}` }
      };
          
      TPIService
        .getDropboxToken(requestOptions).then((result:any) => {
        
          console.log(result);
        })
        .catch(error => console.log('error', error));
    }


  },[]);
  const query = new URLSearchParams(history.location.search);

  const code = query.get('code');
  return (<h1>Successfully logged in to Dropbox</h1>);
};

export default DBSuccess;